import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Trophy, Medal } from "lucide-react";

export default function Leaderboard() {
    const [lang, setLang] = useState("english");
    const [rows, setRows] = useState([]);

    useEffect(() => {
        api.get(`/leaderboard?language=${lang}`).then((r) => setRows(r.data));
    }, [lang]);

    return (
        <div className="max-w-4xl mx-auto px-6 py-10 space-y-8">
            <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
                <div>
                    <p className="eyebrow">Ranks</p>
                    <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight mt-2 flex items-center gap-3">
                        <Trophy className="text-[var(--lt-amber)]" size={40} /> Leaderboard
                    </h1>
                    <p className="text-[var(--lt-muted)] mt-3">
                        Top typists — only test-mode runs count.
                    </p>
                </div>
                <div className="inline-flex rounded-full border border-[var(--lt-border)] p-1 bg-[var(--lt-bg-2)]/60">
                    <button
                        onClick={() => setLang("english")}
                        className={`px-5 py-2 rounded-full text-sm font-semibold transition-all ${
                            lang === "english"
                                ? "bg-[var(--lt-terracotta)] text-white"
                                : "text-[var(--lt-muted)]"
                        }`}
                        data-testid="leaderboard-english-tab"
                    >
                        English
                    </button>
                    <button
                        onClick={() => setLang("nepali")}
                        className={`px-5 py-2 rounded-full text-sm font-semibold transition-all ${
                            lang === "nepali"
                                ? "bg-[var(--lt-terracotta)] text-white"
                                : "text-[var(--lt-muted)]"
                        }`}
                        data-testid="leaderboard-nepali-tab"
                    >
                        नेपाली
                    </button>
                </div>
            </div>

            <div className="glass rounded-2xl overflow-hidden" data-testid="leaderboard-table">
                {rows.length === 0 ? (
                    <div className="p-10 text-center text-[var(--lt-muted)]">
                        No test runs yet. Be the first to claim a spot.
                    </div>
                ) : (
                    <table className="w-full text-sm">
                        <thead>
                            <tr className="text-left eyebrow border-b border-[var(--lt-border)]">
                                <th className="px-6 py-4">Rank</th>
                                <th className="px-6 py-4">Typist</th>
                                <th className="px-6 py-4 text-right">Best WPM</th>
                                <th className="px-6 py-4 text-right">Accuracy</th>
                                <th className="px-6 py-4 text-right hidden sm:table-cell">
                                    Tests
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows.map((r, i) => (
                                <tr
                                    key={r.user_id}
                                    className="border-b border-[var(--lt-border)] last:border-0 hover:bg-[var(--lt-bg-2)]/40"
                                >
                                    <td className="px-6 py-4">
                                        <div className="flex items-center gap-2 font-mono-stat">
                                            {i < 3 && (
                                                <Medal
                                                    size={16}
                                                    className={
                                                        i === 0
                                                            ? "text-[var(--lt-amber)]"
                                                            : i === 1
                                                            ? "text-[var(--lt-muted)]"
                                                            : "text-[var(--lt-terracotta)]"
                                                    }
                                                />
                                            )}
                                            #{i + 1}
                                        </div>
                                    </td>
                                    <td className="px-6 py-4">{r.name}</td>
                                    <td className="px-6 py-4 text-right font-mono-stat text-lg text-[var(--lt-text)]">
                                        {r.best_wpm}
                                    </td>
                                    <td className="px-6 py-4 text-right font-mono-stat text-[var(--lt-muted)]">
                                        {r.best_accuracy}%
                                    </td>
                                    <td className="px-6 py-4 text-right font-mono-stat text-[var(--lt-muted)] hidden sm:table-cell">
                                        {r.total_tests}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
}
